export const OPEN_BANKING_MODAL = 'page/OPEN_BANKING_MODAL';
export const OPEN_BANKING_MODAL_DATA = 'page/OPEN_BANKING_MODAL_DATA';
export const REFRESH_LINKED_ACCOUNTS = 'page/REFRESH_LINKED_ACCOUNTS';
export const CLOSE_BANKING_MODAL = 'page/CLOSE_BANKING_MODAL';
